import { useState } from "react";
import { Show } from "../../../../hooks/Show";
import { EditPackagingModal } from "../../../../components/Modal/WMS/Packaging/EditPackagingModal";

export const EditPackagingButton = ({ isActive = false, idPackaging }) => {
  const [openModalUpdatePackaging, setOpenModalUpdatePackaging] =
    useState(false);

  if (!isActive) return null;

  return (
    <>
      <Show when="feature:wms-packaging-edit">
        <button
          title="Editar"
          className="btn btn-primary btn-sm btn-circle mr-2"
          type="button"
          onClick={() => setOpenModalUpdatePackaging(true)}
        >
          <i className="fas fa-edit fa-xs"></i>
        </button>
      </Show>
      <EditPackagingModal
        show={openModalUpdatePackaging}
        handleClose={() => setOpenModalUpdatePackaging(false)}
        idPackaging={idPackaging}
      />
    </>
  );
};
